import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyLayout from "./PolicyLayout";

const termsSections = [
  {
    title: "Using our store",
    body: [
      `These terms apply when you visit the ${siteConfig.brandName} website or place an order with us. By using the store, you agree to these terms and the policies linked from it.`,
      "You must be able to enter a binding contract and provide accurate contact, payment and delivery information. Products restricted by age may be purchased and received only by a person who meets the applicable legal age requirement.",
    ],
  },
  {
    title: "Products and availability",
    body: [
      "We aim to describe products, origins, allergens, weights and images accurately. Screen colours, artisan production and natural ingredients mean the item delivered may vary slightly from its photograph or stated approximate weight.",
      "All products are subject to availability. If an item becomes unavailable after you order, we will contact you to arrange a suitable substitution, credit or refund; we will not substitute an item without your agreement where allergens or important product characteristics may differ.",
    ],
  },
  {
    title: "Orders and acceptance",
    body: [
      "Submitting checkout is an offer to purchase. An automatic acknowledgement confirms that we received the order, not that we accepted it. Acceptance occurs when we confirm fulfilment or dispatch, and we may decline or limit an order for stock, payment, delivery, pricing-error or suspected misuse reasons.",
      "Please review your order carefully before payment and contact us promptly if anything is incorrect.",
    ],
  },
  {
    title: "Prices and payment",
    body: [
      `Prices are shown in ${siteConfig.currency.code} unless stated otherwise. Delivery charges, discounts and the final total are displayed before you place an order.`,
      "Payment must be authorised through an available checkout method. If a clear pricing or promotional error affects an order, we may cancel the affected item and refund it, or ask whether you wish to proceed at the correct price.",
    ],
  },
  {
    title: "Delivery, title and risk",
    body: [
      "Delivery estimates are provided in good faith and can change because of weather, traffic, access or events outside reasonable control. Responsibility for the order passes to you when it is delivered to the address or authorised safe place you supplied.",
      "You are responsible for refrigerating temperature-sensitive products promptly. Please read our Shipping & delivery policy for fees, coverage and receiving instructions.",
    ],
  },
  {
    title: "Cancellations, returns and refunds",
    body: [
      "Fresh and made-to-order products cannot always be cancelled or returned once preparation has started. Eligibility for a replacement, return, credit or refund is explained in our Returns & refunds policy. Nothing in these terms excludes rights that cannot lawfully be excluded.",
    ],
  },
  {
    title: "Acceptable use and intellectual property",
    body: [
      "You may use the website for lawful personal shopping. You must not disrupt the service, attempt unauthorised access, introduce malicious code, scrape the store at unreasonable volume or use content in a misleading or infringing way.",
      `The site design, original text, graphics and brand assets belong to ${siteConfig.brandName} or their respective licensors. You may not reproduce or commercially exploit them without prior written permission.`,
    ],
  },
  {
    title: "Liability",
    body: [
      "To the fullest extent allowed by law, we are not responsible for indirect or unforeseeable loss arising from use of the store. We do not exclude liability where doing so would be unlawful, including liability for fraud or for personal injury caused by negligence.",
      "Product information is not medical advice. Customers with allergies or dietary requirements should review the current packaging and contact us before consuming a product if anything is unclear.",
    ],
  },
  {
    title: "Governing law and contact",
    body: [
      `These terms are governed by the laws of Hong Kong SAR, and disputes are subject to the jurisdiction of its courts unless mandatory consumer law provides otherwise. Questions can be sent to ${siteConfig.contact.email}.`,
    ],
  },
];

function Terms() {
  return (
    <PolicyLayout
      eyebrow="Legal"
      title="Terms & conditions"
      intro={`The practical terms for browsing, ordering and shopping with ${siteConfig.brandName}.`}
      sections={termsSections}
    />
  );
}

export default Terms;
